import { forwardRef } from "react";

import { ProgressBar } from "./progress-bar";
import { useTranslations } from "../hooks/use-translations";

interface RedirectProgressBarProps {
  redirectUrl: string;
  timeout?: number;
  title?: string;
  onCancel?: () => void;
  autoStart?: boolean;
  showPercentage?: boolean;
}

export interface RedirectProgressBarHandle {
  start: () => void;
  cancel: () => void;
}

export const RedirectProgressBar = forwardRef<RedirectProgressBarHandle, RedirectProgressBarProps>(
  ({ redirectUrl, timeout = 10_000, title, onCancel, autoStart = true, showPercentage = false }, ref) => {
    const { translations } = useTranslations();

    const handleFinish = () => {
      window.location.assign(redirectUrl);
    };

    return (
      <ProgressBar
        ref={ref}
        autoStart={autoStart}
        onCancel={onCancel}
        onFinish={handleFinish}
        showPercentage={showPercentage}
        timeout={timeout}
        title={title ?? translations.common.redirecting}
      />
    );
  },
);

RedirectProgressBar.displayName = `RedirectProgressBar`;
